import { getVideoFilePath } from "../constants/pathConstants"
import { AnalysisData, AnalysisFeedback, AnalysisFeedbackDataAngle, AnalysisFeedbackDataArrow, AnalysisFeedbackDataLine, AnalysisFeedbackDataRecording, AnalysisFeedbackDataShapeRectangle, AnalysisFeedbackDataText, AnalysisFeedbackTypes } from '../types/videoAnalysisTypes';

// Analysis state data class
class AnalysisStateData {
	analysisDataLoaded: boolean = false
	analysisData: AnalysisData | undefined
	videoSrc: string = ''

	recordingStartDate: Date | undefined

	currentFeedbackIndex: number = 0

	// constructor() {
	// }

	public createNewFeedback(type: AnalysisFeedbackTypes, time: number) {
		if (!this.analysisData) {
			this.analysisData = {
				videoFileName: '',
				feedbacks: []
			} // new AnalysisData
		}
		this.analysisData.feedbacks.push({
				type: type,
				time: time,
				duration: 2000,
				data: undefined
			}
		)
		this.currentFeedbackIndex = this.analysisData.feedbacks.length - 1
	}
	
	public updateCurrentFeedbackDuration(time: number) {
		if (this.analysisData) {
			if (this.analysisData.feedbacks[this.currentFeedbackIndex]) {
				this.analysisData.feedbacks[this.currentFeedbackIndex].duration = time
			}
		}
	}

	public updateCurrentFeedbackData(
		data: 
			AnalysisFeedbackDataText |
			AnalysisFeedbackDataArrow |
			AnalysisFeedbackDataLine |
			AnalysisFeedbackDataAngle |
			AnalysisFeedbackDataShapeRectangle |
			AnalysisFeedbackDataRecording
		) {
		if (this.analysisData) {
			// if (!this.analysisData.feedbacks[this.currentFeedbackIndex]) {

			// }
			if (this.analysisData.feedbacks[this.currentFeedbackIndex]) {
				this.analysisData.feedbacks[this.currentFeedbackIndex].data = data
			}
		}
	}

	public getFeedbacks(): AnalysisFeedback[] {
		if (this.analysisData) {
			if (this.analysisData.feedbacks && this.analysisData.feedbacks.length > 0) {
				return this.analysisData.feedbacks
			}
			return []
		}
		return []
	}

	public getCurrentFeedback(): AnalysisFeedback | undefined {
		if (this.analysisData) {
			if (this.analysisData.feedbacks[this.currentFeedbackIndex]) {
				return this.analysisData.feedbacks[this.currentFeedbackIndex]
			}
			return undefined
		}
		return undefined
	}

	public getVideoSrc(): string | undefined {
		if (this.analysisData) {
			return `${getVideoFilePath()}${this.analysisData.videoFileName}`
			// return this.analysisData.videoFileName
		}
		return undefined
	}

	public setAnalysisData(data: AnalysisData) {
		this.analysisData = data
	}

	public setVideoSrc(src: string) {
		this.videoSrc = src
	}
}

export const analysisStateData: AnalysisStateData = new AnalysisStateData()